/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * Your Project
 * API for all things …
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  MSViewer
} from '../../schema'


/**
 * List all viewers
 */
export const listMSViewers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MSViewer[]>> => {
    return axios.get(
      `/viewer/`,options
    );
  }


export const getListMSViewersQueryKey = () => [`/viewer/`];

    
export type ListMSViewersQueryResult = NonNullable<Awaited<ReturnType<typeof listMSViewers>>>
export type ListMSViewersQueryError = AxiosError<unknown>

export const useListMSViewers = <TData = Awaited<ReturnType<typeof listMSViewers>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMSViewers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMSViewersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMSViewers>>> = ({ signal }) => listMSViewers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof listMSViewers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

